import React, { useState } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { baseUrl } from '../../urlApi';



var validator = require("email-validator");

export const ChangeEmail = () => {


      const strcon = useSelector(state => state.login.token)
      const { state } = useLocation();


     
  const [estadoCambio, setEstadoCambio] = useState(0)



  const [nuevoEmail, setNuevoEmail] = useState('')
  const [repeatEmail, setRepeatEmail] = useState('')

  let navigate = useNavigate();


  const changeEmail = async() => {

    

      if(!validator.validate(nuevoEmail)){
 

       Swal.fire({
            title: 'Ingresa un Email valido',
            text: 'Intentalo otra vez',
            confirmButtonColor:'#2ec1db',
            
          })
 
       return
      }
 
 
      if(nuevoEmail !== repeatEmail){
 

       Swal.fire({
            title: 'Emails ingresados son diferentes',
            text: 'Intentalo otra vez',
            confirmButtonColor:'#2ec1db',            
       })
 
 
 
       return
      }
 
 
 
         try {
 
            const response = await axios.post(`${baseUrl}email.asp`, {
             strcon, email:nuevoEmail
            })
 
            // console.log('respuesta',response.data)
            setEstadoCambio(response.data.resultado)
           
         } catch (error) {
           console.log(error)
         }
 
 
    }
 
    const volver = () => {
     setEstadoCambio(0)
     setNuevoEmail('')
     setRepeatEmail('')
     navigate('/datos')
   }

   const pressEnter = (e) => {
      if(e.key === 'Enter'){
            changeEmail()
      }
    
    }




  return (
    <>    
           {
                 estadoCambio !== 0 ?

                 <div className='contenedorCambiarEmail'>


                 <div className='titulo marginTopLoading' >

                      <p>Email cambiado </p>



                  </div>

                  <button onClick={volver} className='buttonCertificado cambiarEmailBtn' >

                          <p>Volver</p>  

                  </button>

                  </div>

                 :
                 <div className='contenedorCambiarEmail'>


                        <div className='titulo' >

                              <p>Cambiar Email</p>

                        </div>


                        <div className='contenedorCambio'>
                              <label> Email actual </label>
                              <input type='text' placeholder={state}  disabled={true} />

                        </div>

                        <div className='contenedorCambio'>
                              <label> Nuevo email  </label>
                              <input type='text' onKeyPress={pressEnter} onChange={e => setNuevoEmail(e.target.value)} />

                        </div>


                        <div className='contenedorCambio'>
                              <label> Repita el nuevo email </label>
                              <input type='text' onKeyPress={pressEnter}  onChange={e => setRepeatEmail(e.target.value)}   />

                        </div>



                        {/* <button onClick={changeEmail} className='buttonEmail ' >

                              <p>Cambiar Email</p>  

                        </button> */}



                 </div>
           }


         


    </>
  )
}
